module.exports = __webpack_public_path__ + "media/images/diamond-207e619fbc413e86c6d7da0836b3973a.svg";